<template>
  <div class="auto-scroll-image">
    <div class="scroll-container">
      <img
        ref="scrollRef"
        ondragstart="return false;"
        class="scroll-img"
        src="../../assets/images/estate/estate.png"
        :style="{ left: imgLeft + 'px' }"
      />
    </div>
    <div class="progress-box">
      <div class="progress-item">
        <div class="nst-bar" :style="{ width: scrollLeft + 'px' }"></div>
        <div
          class="progress-bar"
          auto="false"
          :style="{ left: scrollLeft + 'px' }"
          @mousedown="startDrag"
        >
          <p></p>
        </div>
      </div>
    </div>

    <div class="shadow-left"></div>
    <div class="shadow-right"></div>
  </div>
</template>

<script>
export default {
  name: "AutoScrollImage",
  data() {
    return {
      imgLeft: 0,
      scrollLeft: 0,
      scrollTimer: null, // 用于存储定时器的变量
      isDragging: false,

      startX: 0,
      trackWidth: 460,
    };
  },
  mounted() {
    // 开始自动滚动
    this.startAutoScroll();
  },
  methods: {
    handleScroll(val) {
      const proportion =
        (this.$refs.scrollRef.clientWidth - window.innerWidth) / 440;
      const imgLeft = val * proportion;
      this.imgLeft = -imgLeft;
    },
    startAutoScroll() {
      this.scrollTimer = setInterval(() => {
        if (this.scrollLeft <= 440) {
          this.scrollLeft++;
          this.$nextTick(() => {
            this.handleScroll(this.scrollLeft);
          });
        } else {
          clearInterval(this.scrollTimer);
          this.scrollTimer = null;
          this.scrollLeft = 0;
          this.startAutoScroll();
        }
      }, 100); // 每隔100毫秒滚动一次
    },
    stopAutoScroll() {
      this.scrollTimer && clearInterval(this.scrollTimer);
      this.scrollTimer = null;
    },

    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      document.addEventListener("mousemove", this.drag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    drag(e) {
      if (!this.isDragging) return;
      this.stopAutoScroll();
      const currentX = e.clientX;
      let offsetX = currentX - this.startX;
      if (offsetX < 0) {
        offsetX = 0;
      } else if (
        offsetX >
        document.documentElement.clientWidth - e.offsetWidth
      ) {
        offsetX = document.documentElement.clientWidth - e.offsetWidth;
      } else if (offsetX >= 440) {
        offsetX = 440;
      }

      this.scrollLeft = offsetX;
      this.$nextTick(() => {
        this.handleScroll(offsetX);
      });
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.drag);
      document.removeEventListener("mouseup", this.stopDrag);
      setTimeout(() => {
        this.startAutoScroll();
      }, 1000);
    },
  },
  beforeDestroy() {
    this.stopAutoScroll();
  },
};
</script>

<style lang="scss" scoped>
.auto-scroll-image {
  position: relative;
  .scroll-container {
    height: 494px;
    overflow: auto;
    width: 100%;
    overflow: hidden;
    position: relative;
    max-width: 1462px;
    margin: 0 auto;
  }
  .scroll-img {
    height: 100%;
    width: 5330px;
    position: absolute;
    transition: all 0.2s linear;
  }

  .progress-box {
    position: absolute;
    width: 460px;
    height: 2px;
    top: 470px;
    left: 50%;
    margin-left: -220px;
    border-radius: 10px;
  }

  .progress-item {
    width: 100%;
    height: 100%;
    position: relative;
    background: #ccc;
    border-radius: 10px;
  }

  .nst-bar {
    position: absolute;
    left: 0;
    height: 100%;
    width: 0;
    background: #007116;
    top: 0;
    border-radius: 10px;
  }

  .progress-bar {
    cursor: pointer;
    width: 20px;
    height: 20px;
    top: -9px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    background: #007116;
    display: flex;
    justify-content: center;
    align-items: center;

    > p {
      border-radius: 50%;
      width: 16px;
      height: 16px;
      background: #fff;
    }
  }

  .shadow-left {
    left: 0;
    top: 0;
    position: absolute;
    width: 16%;
    height: 100%;
    background: linear-gradient(
      to left,
      rgba(238, 239, 240, 0) 0%,
      rgba(238, 239, 240, 0.5) 50%,
      rgba(238, 239, 240, 1) 100%
    );
  }

  .shadow-right {
    right: 0;
    top: 0;
    position: absolute;
    width: 16%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(238, 239, 240, 0) 0%,
      rgba(238, 239, 240, 0.5) 50%,
      rgba(238, 239, 240, 1) 100%
    );
  }
}
</style>
